import React, { useState, useEffect, useContext, createContext } from 'react';
import { useRef } from 'react';

import { DataContext } from '../../../init/getData';
import { DynamicModalContext } from '../../../init/dynamicModals';
import { PosCartContext } from '../../../init/posCartData';
import ReactToPrint from 'react-to-print';
import { Modal, Col, Form, Row, } from 'react-bootstrap';
import { Button, Divider, Switch } from 'antd';
import print from '../../../components/print/print';
import toast from 'react-hot-toast';
import { numberFormatter } from '../../../components/formatters/numberFormatter';
import Exchange from './exchange';
import ComponentToPrint from '../../../components/print/componentToPrint';
import { useReactToPrint } from 'react-to-print';
import Select from 'react-select';


function PayCashModal(props) {
  let { showModal, toggleModal, closePos, title, totalPrice, totalBeforeVat, transactions, totalDiscounts,
    selectedTab, selectedCurrency, isPrinting, jvCost, jvProfit, jvId, myId, refreshTableFunction,
    auxAccountData, ratedTotalPrice, ratedSymbol, totalVatAmount, setTransactions, tableNumber } = props;

  const { tabData, setCart, resetJournalVoucher, setJournalVoucher } = useContext(PosCartContext);
  const { userData, rateMainToSecondaryCurrency, rateToMainCurrency, settingData, sessionId, mainCurrency, currencyData, selectedCompany,
    serverApi, localApi, devData, cashAccountOptions, deliveryData, companyData } = useContext(DataContext);
  const { setAddedCustomer } = useContext(DynamicModalContext);

  const userRole = userData.role;
  const changeCashAccount = userRole.changeCashAccount;

  const [loadingEffect, setLoadingEffect] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [details, setDetails] = useState('');
  const [saveCustomerPrice, setSaveCustomerPrice] = useState(false);
  const controller = new AbortController();

  const today = new Date().toISOString().split('T')[0];
  const isUsingMainCurrency = selectedCurrency.id == mainCurrency.id ? true : false;

  const mainCurrencyForOfficialPrint = currencyData?.find(option => option.id === settingData.mainCurrencyId) || null;
  const secondaryCurrency = currencyData?.find(option => option.id === settingData.secondaryCurrencyId) || null;

  const secondaryTotalBeforeVat = rateMainToSecondaryCurrency(totalBeforeVat);

  const isEdit = tabData[selectedTab]?.isEdit;

  let api;
  if (devData?.isServer) {
    api = localApi;
  } else if (devData?.isOffline) {
    api = localApi;
  } else if (devData?.isClient) {
    api = serverApi;
  }

  const cart = tabData[selectedTab].cart;
  let journalVoucher = tabData[selectedTab].journalVoucher;
  const cashAccountId = journalVoucher?.cashAccountId;

  const printComponentRef = useRef();
  const [isOfficialPrinting, setIsOfficialPrinting] = useState(false);
  const [officialReceiptData, setOfficialReceiptData] = useState(null);

  const handleSubmit = async (isOrder) => {
    setLoadingEffect(true);

    let updatedJv = getJv(isOrder);
    let updatedCart = cart;
    let updatedTransactions = transactions;

    if (devData?.isOffline) {
      const offlineData = offlineJv(updatedJv, updatedCart, updatedTransactions);
      updatedJv = offlineData.updatedJv;
      updatedCart = offlineData.updatedCart;
      updatedTransactions = offlineData.updatedTransactions;
    }

    const data = {
      userId: userData.id,
      sessionId,
      jvId: jvId,
      journalVoucher: updatedJv,
      cart: updatedCart,
      transactions: updatedTransactions,
      charges: [],
      isOffline: devData?.isOffline,
      saveCustomerPrice,
    }

    const operation = isEdit ? 'edit' : 'add';
    try {
      let res = await api.post(`journalVoucher/${operation}`, data, { signal: controller.signal });

      if (res.data.status) {
        toast.success(res.data.message);
        if (isEdit) {
          refreshTableFunction();
        }

        if (isPrinting) {
          const accountPrint = res?.data?.account;

          if (accountPrint) {
            const isCash = updatedJv.paymentType == 'cash';
            const newBalance = isCash ? accountPrint?.balance : parseFloat(accountPrint.balance) + parseFloat(updatedJv.totalCredit);
            const secondaryNewBalance = isCash ? accountPrint?.secondaryBalance : parseFloat(accountPrint.secondaryBalance) + parseFloat(updatedJv.secondaryTotalCredit);
            accountPrint.newBalance = newBalance;
            accountPrint.secondaryNewBalance = secondaryNewBalance;
          }

          const deliveryPrint = updatedJv.deliveryId ?
            deliveryData.find(delivery => delivery.id === updatedJv.deliveryId) :
            null;

          const companyPrint = updatedJv.companyId ?
            companyData.find(company => company.id === updatedJv.companyId) :
            null;

          const printData = {
            cart: cart || [],
            invoiceId: res.data?.jvId || jvId,
            company: companyPrint,
            account: accountPrint,
            delivery: deliveryPrint,
            userName: userData.name,
            vatAmount: totalVatAmount,
            journalVoucher: {
              ...updatedJv,
              cart: cart || []
            },
            discountPercentage: updatedJv.discountPercentage,
            currency: selectedCurrency,
            settingData: settingData,
            ratedTotalPrice: ratedTotalPrice,
            ratedSymbol: ratedSymbol,
            isUsingMainCurrency,
          }

          setOfficialReceiptData({
            journalVoucher: {
              ...updatedJv,
              id: res.data?.jvId || jvId,
              myId: res.data?.myId || myId,
              company: {
                name: companyPrint?.name || selectedCompany?.name,
                registrationNumber: companyPrint?.registrationNumber || selectedCompany?.registrationNumber,
                address: companyPrint?.address || selectedCompany?.address,
                phone: companyPrint?.phone || selectedCompany?.phone
              },
              account: {
                ...accountPrint,
                registration: accountPrint?.registration || journalVoucher?.account?.registration,
              },
              currency: selectedCurrency,
              cart: cart.map(item => ({
                ...item,
                product: item.product || { name: item.name },
              })) || []
            },
            vatAmount: totalVatAmount,
            isUsingMainCurrency,
            mainCurrency: selectedCurrency,
            secondaryCurrency,
            rateMainToSecondaryCurrency,
            selectedCompany,
            secondaryVatAmount: rateMainToSecondaryCurrency(totalVatAmount)
          });
          
          // Call print function based on setting
          await printInvoice(printData);
        } else {
          closeModal();
          setLoadingEffect(false);
        }
      } else {
        toast.error(res.data.message);
        setLoadingEffect(false);
      }
    } catch (error) {
      setLoadingEffect(false);
      toast.error("Error:", error);
    }
  }

  const getJv = (isOrder) => {
    const updatedJv = { ...journalVoucher }
    const isDebit = updatedJv.isDebit;

    updatedJv.isOrder = isOrder;
    if (!isEdit) {
      updatedJv.date = today;
    }
    jvCost = rateToMainCurrency(selectedCurrency, jvCost);
    jvProfit = rateToMainCurrency(selectedCurrency, jvProfit);

    const discountAmount = rateToMainCurrency(selectedCurrency, totalDiscounts);
    const secondaryDiscountAmount = rateMainToSecondaryCurrency(discountAmount);

    const secondaryJvCost = rateMainToSecondaryCurrency(jvCost);
    const secondaryJvProfit = rateMainToSecondaryCurrency(jvProfit);

    updatedJv.cost = jvCost;
    updatedJv.profit = jvProfit;

    updatedJv.secondaryCost = secondaryJvCost;
    updatedJv.secondaryProfit = secondaryJvProfit;

    updatedJv.discountAmount = discountAmount;
    updatedJv.secondaryDiscountAmount = secondaryDiscountAmount;

    const totalDebit = rateToMainCurrency(selectedCurrency, totalPrice);
    const totalCredit = rateToMainCurrency(selectedCurrency, totalPrice);

    const secondaryTotalDebit = rateMainToSecondaryCurrency(totalDebit);
    const secondaryTotalCredit = rateMainToSecondaryCurrency(totalCredit);

    updatedJv.debit = totalPrice;
    updatedJv.credit = totalPrice;

    updatedJv.totalDebit = totalCredit;
    updatedJv.totalCredit = totalCredit;

    updatedJv.secondaryTotalDebit = secondaryTotalDebit;
    updatedJv.secondaryTotalCredit = secondaryTotalCredit;

    let jvType;
    if (isDebit) {
      if (!isOrder) {
        jvType = 'PosReturn';
      } else {
        jvType = 'PosReturnOrder';
      }
    } else {
      if (!isOrder) {
        jvType = 'PosSale';
      } else {
        jvType = 'PosOrder';
      }
    }
    updatedJv.type = jvType;
    updatedJv.details = details;

    return updatedJv
  }

  const offlineJv = (updatedJv, cart, transactions) => {
    updatedJv.offlineCreatedBy = updatedJv.createdBy;
    delete updatedJv.createdBy;

    updatedJv.offlineCashAccountId = updatedJv.cashAccountId;
    delete updatedJv.cashAccountId;

    updatedJv.offlineYearId = updatedJv.yearId;
    delete updatedJv.yearId;

    updatedJv.offlineCompanyId = updatedJv.companyId;
    delete updatedJv.companyId;

    updatedJv.offlineBranchId = updatedJv.branchId;
    delete updatedJv.branchId;

    updatedJv.offlineProjectId = updatedJv.projectId;
    delete updatedJv.projectId;

    updatedJv.offlineWarehouseId = updatedJv.warehouseId;
    delete updatedJv.warehouseId;

    updatedJv.offlineTransferWarehouseId = updatedJv.transferWarehouseId;
    delete updatedJv.transferWarehouseId;

    updatedJv.offlineCurrencyId = updatedJv.currencyId;
    delete updatedJv.currencyId;

    updatedJv.offlineDeletedById = updatedJv.deletedBy;
    delete updatedJv.deletedBy;

    updatedJv.offlineSessionId = updatedJv.sessionId;
    delete updatedJv.sessionId;

    updatedJv.offlineAccountId = updatedJv.accountId;
    delete updatedJv.accountId;

    updatedJv.offlineSecondaryAccountId = updatedJv.secondaryAccountId;
    delete updatedJv.secondaryAccountId;

    updatedJv.offlineDeliveryId = updatedJv.deliveryId;
    delete updatedJv.deliveryId;

    const updatedTransactions = transactions.map((item) => {
      let newItem = { ...item };

      newItem.offlineAccountId = newItem.accountId;
      delete newItem.accountId;

      newItem.offlineCurrencyId = newItem.currencyId;
      delete newItem.currencyId;

      newItem.offlineWarehouseId = newItem.warehouseId;
      delete newItem.warehouseId;

      return newItem;
    });

    const updatedCart = cart.map((item) => {
      let newItem = { ...item };
      newItem.offlineProductId = newItem.productId;
      delete newItem.productId;
      return newItem;
    });

    return {
      updatedJv,
      updatedCart,
      updatedTransactions,
    };
  }

  const closeModal = () => {
    resetJournalVoucher(selectedTab);
    toggleModal();
    setAddedCustomer(null);

    if (isEdit) {
      closePos()
    };
  }

  const printInvoice = async (printData) => {
    if (isOfficialPrinting) {
      await new Promise(resolve => setTimeout(resolve, 100));
      handleReactToPrint();
      setLoadingEffect(false);
    } else {
      // Check if we should use IP printing or browser printing
      if (settingData?.useIpPrint) {
        // Use IP printing with printer IP from settings
        try {
          const ipPrintData = {
            userName: printData.userName,
            cart: printData.cart.map(item => ({
              name: item.name || item.product?.name,
              category: item.product?.category?.name,
              quantity: item.quantity,
              netQuantity: item.netQuantity,
              price: item.price || item.itemPrice,
              itemPrice: item.itemPrice,
              totalPrice: item.totalPrice,
              priceDiscountPercentage: item.priceDiscountPercentage,
              details: item.details,
              product: item.product
            })),
            lbp: printData.ratedTotalPrice || 0,
            usd: printData.journalVoucher?.credit || 0,
            type: printData.journalVoucher?.type || 'Sale',
            printerIp: settingData.printerIp,
            settingData: settingData,
            // Pass the full print data to match the design
            printData: {
              ...printData,
              invoiceId: printData.invoiceId,
              account: printData.account,
              delivery: printData.delivery,
              journalVoucher: printData.journalVoucher,
              vatAmount: printData.vatAmount,
              discountPercentage: printData.discountPercentage,
              currency: printData.currency,
              ratedTotalPrice: printData.ratedTotalPrice,
              ratedSymbol: printData.ratedSymbol,
              isUsingMainCurrency: printData.isUsingMainCurrency
            }
          };

          const response = await api.post('print/printIp', ipPrintData);
          
          if (response.data.status) {
            toast.success('Printed successfully via IP printer');
          } else {
            toast.error('IP printing failed, falling back to browser print');
            print(printData);
          }
        } catch (error) {
          console.error('IP printing error:', error);
          toast.error('IP printing failed, falling back to browser print');
          print(printData);
        }
      } else {
        // Use browser printing
        print(printData);
      }
      
      closeModal();
      setLoadingEffect(false);
    }
  };

  const handleReactToPrint = useReactToPrint({
    content: () => printComponentRef.current,
    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        if (printComponentRef.current) {
          resolve();
        }
      });
    },
    onAfterPrint: () => {
      setIsOfficialPrinting(false);
      closeModal();
      setLoadingEffect(false);
    },
    removeAfterPrint: true,
    onPrintError: (error) => {
      console.error('Print error:', error);
      setIsOfficialPrinting(false);
    }
  });

  const handleCashChange = (cashAccountId) => {
    let updatedJv = { ...journalVoucher };
    updatedJv.cashAccountId = cashAccountId;
    setJournalVoucher(updatedJv, selectedTab);
  };

  return (
    <Modal show={showModal} onHide={toggleModal} backdrop='static' className='Delete_modal'>
      <Modal.Header style={{ background: "#1d7790" }} closeButton>
        <Modal.Title className="arabicText" style={{ color: "white" }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="arabicText">
        <Row style={{ textAlign: 'center' }}>
          <span style={{ fontWeight: 'bold', fontSize: '30px' }}> Net Total:  {numberFormatter(totalPrice)} </span>
        </Row>

        <Row className='mb-3'>
          <Col>
            <Form.Control as="textarea" value={details} onChange={e => setDetails(e.target.value)} autoFocus rows={2} />
          </Col>
        </Row>

        <Row className='mb-3'>
          <Col>
            <Select
              options={cashAccountOptions}
              isSearchable={true}
              placeholder="Select"
              onChange={(e) => handleCashChange(e?.value)}
              defaultValue={cashAccountOptions?.find(option => option.value === cashAccountId)}
              required
              isDisabled={!changeCashAccount}
            />
          </Col>
        </Row>

        <Row className='mt-3 mb-3' style={{ textAlign: 'center' }}>
          <Col md={4}></Col>
          <Col md={4}>
            <Form.Select value={isOfficialPrinting ? "true" : "false"}
              onChange={(e) => setIsOfficialPrinting(e.target.value === "true")}>
              <option value="false">Receipt Print</option>
              <option value="true">Invoice Print</option>
            </Form.Select>
          </Col>
          <Col md={4}></Col>
        </Row>

        {settingData.useCustomerPrice &&
          <Row className='mb-3'>
            <Col md={2}></Col>
            <Col md={5}>
              <Form.Label>Save Customer Price</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: saveCustomerPrice ? '#23576a' : '#bebfbe' }}
                checked={saveCustomerPrice}
                onChange={(e) => setSaveCustomerPrice(e)} />
            </Col>
          </Row>
        }

        {settingData.moneyExchange && (
          <Exchange
            finalNetTotal={totalPrice}
            selectedCurrency={selectedCurrency}
          />
        )}

        <Divider />

        <Row>
          <Col>
            <Button
              type="button"
              loading={loadingEffect}
              style={{ height: '80px', width: '100%', backgroundColor: '#b7e3f2', fontWeight: 'bold' }}
              className="btn btn-lg"
              onClick={() => handleSubmit(true)} >
              {tableNumber ? 'Save' : 'Order'}
            </Button>
          </Col>

          {journalVoucher.paymentType == 'cash' &&
            <Col>
              <Button
                type="button"
                loading={loadingEffect}
                style={{ height: '80px', width: '100%', backgroundColor: '#a4c436', fontWeight: 'bold' }}
                className="btn btn-lg"
                onClick={() => handleSubmit(false)} >
                Cash
              </Button>
            </Col>
          }

          {journalVoucher.paymentType == 'onAccount' &&
            <Col>
              <Button
                type="button"
                loading={loadingEffect}
                style={{ height: '80px', width: '100%', backgroundColor: '#eb5355', fontWeight: 'bold' }}
                className="btn btn-lg"
                onClick={() => handleSubmit(false)} >
                Credit
              </Button>
            </Col>
          }
        </Row>
      </Modal.Body>

      {isOfficialPrinting && officialReceiptData &&
        <div style={{ display: 'none' }}>
          <ComponentToPrint
            ref={printComponentRef}
            journalVoucher={officialReceiptData.journalVoucher}
            vatAmount={officialReceiptData.vatAmount}
            isUsingMainCurrency={isUsingMainCurrency}
            mainCurrency={mainCurrency}
            secondaryCurrency={secondaryCurrency}
            rateMainToSecondaryCurrency={rateMainToSecondaryCurrency}
            selectedCompany={selectedCompany}
            secondaryVatAmount={rateMainToSecondaryCurrency(officialReceiptData.vatAmount)}
            totalBeforeVat={totalBeforeVat}
            secondaryTotalBeforeVat={secondaryTotalBeforeVat}
          />
        </div>
      }
    </Modal>
  );
}

export default PayCashModal;